import { render } from "./TableContainer.vue?vue&type=template&id=3fd13cd1&scoped=true&ts=true"
import script from "./TableContainer.ts?vue&type=script&lang=ts"
export * from "./TableContainer.ts?vue&type=script&lang=ts"

import "./TableContainer.css?vue&type=style&index=0&id=3fd13cd1&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fd13cd1"]])

export default __exports__